import {createSlice} from "@reduxjs/toolkit";
import {getStorage, setStorage} from "../api/_token.js";
import {getFilter} from "./assets-duck.js";

export const NAME = 'chart';

export const CHART_DURATIONS = {
    31: {
        name: "Month",
        shortname: "1m",
        isHiddenMobile: false,
    },
    92: {
        name: "3 months",
        shortname: "3m",
        isHiddenMobile: false,
    },
    ytd: {
        name: "Year to date",
        shortname: "ytd",
        isHiddenMobile: false,
    },
    365: {
        name: "Year",
        shortname: "1y",
        isHiddenMobile: false,
    },
    1096: {
        name: "Year",
        shortname: "3y",
        isHiddenMobile: true,
    },
    1826: {
        name: "5 years",
        shortname: "5y",
        isHiddenMobile: true,
    },
    3652: {
        name: "All",
        shortname: "All",
        isHiddenMobile: false,
    },
}

export const CHART_DURATION_ORDER = ['31', '92', 'ytd', '365', '1096', '1826', '3652']

export const CHART_FOCUSES = {
    gain: {
        name: "return",
        shortname: "gain",
    },
    value: {
        name: "value",
        shortname: "Val",
    },
}

const initialState = {
    chartDuration: getStorage('chart-duration', 92),
    chartFocus: getStorage('chart-focus', 'gain'),
    chartHoverDate: undefined,
    transactionHoverDate: undefined,
    transactionHoverType: undefined,
    transactionHoverAssetCode: undefined,
    transactionHoverAssetCodeFrom: undefined,
    transactionHoverIsProfit: undefined,
    diffTrackerValues: {
        date: undefined,
        value: 0,
        valuePrev: 0,
        gain: 0,
        gainPrev: 0,
        return: 0,
        relativePosition: 0,
    },
    isDiffTrackerVisible: false,
    showLatestValue: getStorage('show-latest', true),
    isAthGolden: getStorage('is-ath-golden', true),
    isZeroBaseValue: getStorage('is-zero-base', false),
    showTxAnnotations: getStorage('show-tx-annotations', false),
    showTxAnnotationsDividends: getStorage('show-tx-annotations-dividends', false),
}

const {actions, reducer} = createSlice({
    name: NAME,
    initialState,
    reducers: {
        setChartDuration: (state, {payload}) => {
            setStorage('chart-duration', payload)
            state.chartDuration = payload
        },
        setChartFocus: (state, {payload}) => {
            setStorage('chart-focus', payload)
            state.chartFocus = payload
        },
        setChartHoverDate: (state, {payload}) => {
            state.chartHoverDate = payload
        },
        setTransactionHoverDate: (state, {payload}) => {
            state.transactionHoverDate = payload?.date
            state.transactionHoverType = payload?.type
            state.transactionHoverAssetCode = payload?.assetCode
            state.transactionHoverAssetCodeFrom = payload?.assetCodeFrom
            state.transactionHoverIsProfit = payload?.isProfit
        },
        setDiffTrackerValues: (state, {payload}) => {
            state.diffTrackerValues = {
                ...payload
            }
            state.isDiffTrackerVisible = true
        },
        setIsDiffTrackerVisible: (state, {payload}) => {
            state.isDiffTrackerVisible = payload
        },
        setShowLatestValue: (state, {payload}) => {
            setStorage('show-latest', payload)
            state.showLatestValue = payload
        },
        setIsAthGolden: (state, {payload}) => {
            setStorage('is-ath-golden', payload)
            state.isAthGolden = payload
        },
        setIsZeroBaseValue: (state, {payload}) => {
            setStorage('is-zero-base', payload)
            state.isZeroBaseValue = payload
        },
        setShowTxAnnotations: (state, {payload}) => {
            setStorage('show-tx-annotations', payload)
            state.showTxAnnotations = payload
        },
        setShowTxAnnotationsDividends: (state, {payload}) => {
            setStorage('show-tx-annotations-dividends', payload)
            state.showTxAnnotationsDividends = payload
        },
        reset: () => ({
            ...initialState
        }),
    }
})

export const {
    setChartDuration,
    setChartFocus,
    setChartHoverDate,
    setTransactionHoverDate,
    setDiffTrackerValues,
    setIsDiffTrackerVisible,
    setShowLatestValue,
    setIsAthGolden,
    setIsZeroBaseValue,
    setShowTxAnnotations,
    setShowTxAnnotationsDividends,
} = actions

const getState = state => state[NAME]

export const getChartDuration = state => getState(state).chartDuration
export const getChartFocus = state => getState(state).chartFocus
export const getChartHoverDate = state => getState(state).chartHoverDate
export const getTransactionHoverDate = state => getState(state).transactionHoverDate
export const getTransactionHoverType = state => getState(state).transactionHoverType
export const getTransactionHoverAssetCode = state => getState(state).transactionHoverAssetCode
export const getTransactionHoverAssetCodeFrom = state => getState(state).transactionHoverAssetCodeFrom
export const getTransactionHoverIsProfit = state => getState(state).transactionHoverIsProfit
export const getDiffTrackerValues = state => getState(state).diffTrackerValues
export const getIsDiffTrackerVisible = state => getState(state).isDiffTrackerVisible
export const getShowLatestValue = state => getState(state).showLatestValue
export const getIsAthGolden = state => getState(state).isAthGolden
export const getIsZeroBaseValue = state => getState(state).isZeroBaseValue
export const getShowTxAnnotations = state => getState(state).showTxAnnotations
export const getShowTxAnnotationsDividends = state => getState(state).showTxAnnotationsDividends

export const getUpdateKey = state => getFilter(state)

export default reducer